import { createAsyncThunk, } from "@reduxjs/toolkit";
import { endpoint } from "../../../utils/constants/endpoint";
import client from "../../../app/core/client-http/client";
import { actions as appActions } from "../../../app/appSlice";


export const doGetStudioById = createAsyncThunk(
  "login/get-studio-by-id",
  async ({ studioId, token }, thunkAPI) => {
    const response = await client.get(
      endpoint.ADMIN_STUDIO.STUDIO + "/" + studioId,
      null,
      {
        extraHeader: {
          key: "Authorization",
          value: `Bearer ${token}`,
        },
      }
    );

    thunkAPI.dispatch(
      appActions.setLogoImageURL({
        logoImageURL: response.data.Data.logoImageUrl,
      })
    );
    if (response.data.Data.primaryColor && response.data.Data.secondaryColor)
      return thunkAPI.dispatch(
        appActions.setColors({
          primaryColor: response.data.Data.primaryColor,
          secondaryColor: response.data.Data.secondaryColor,
        })
      );
  }
);

